import Validator from "validatorjs";
import { validateIdCard, validatePhone } from "./validate-util";

Validator.register(
  "idCard",
  // eslint-disable-next-line no-unused-vars
  function(value, requirement, attribute) {
    // requirement parameter defaults to null
    return validateIdCard(value);
  },
  "身份证号错误"
);

Validator.register(
  "phone",
  // eslint-disable-next-line no-unused-vars
  function(value, requirement, attribute, passes) {
    // requirement parameter defaults to null
    return validatePhone(value);
  },
  ":attribute error"
);

export function firstError(errors) {
  for (let error in errors) {
    return errors[error][0];
  }
}

export function ValidatorPlugin(Vue) {
  Vue.prototype.$validate = function(data, rules, attrs) {
    let validator = new Validator(data, rules);
    validator.setAttributeNames(attrs);

    return new Promise((resolve, reject) => {
      if (validator.passes()) {
        resolve();
      } else {
        const errors = validator.errors.all();
        reject(firstError(errors), errors);
      }
    });
  };
}
